export default __webpack_public_path__ + "static/media/carNet.510674f7.png";